<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <strong>Profilo</strong>
      </div>
      <b-form-group>
        <label for="firstName">Nome</label>
        <b-form-input disabled v-model="subuser.firstName" type="text" id="firstName" placeholder=""></b-form-input>
      </b-form-group>
      <b-form-group>
        <label for="lasttName">Cognome</label>
        <b-form-input disabled v-model="subuser.lastName" type="text" id="lasttName" placeholder=""></b-form-input>
      </b-form-group>
      <b-form-group>
        <label for="lasttName">Cellulare</label>
        <b-form-input disabled v-model="subuser.mobilePhone" type="text" id="lasttName" placeholder=""></b-form-input>
      </b-form-group>
      <b-form-group>
        <label for="lasttName">Email</label>
        <b-form-input disabled v-model="subuser.email" type="text" id="lasttName" placeholder=""></b-form-input>
      </b-form-group>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'profile',
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'subuser',
    ])
  },
}
</script>
